import React from 'react';
import { Link } from 'react-router-dom';
import { formatArticleCategories } from '../utils/articleCategories';
import { formatDeskTime } from '../pages/desk/deskConfig';
import styles from './ArticleTeaser.module.css';

const ArticleTeaser = ({ article, onArticleClick }) => {
  const cats = formatArticleCategories(article);
  const source = article.source || article.feedName;
  const href = `/article/${article.id}`;

  return (
    <article className={styles.card}>
      <h3 className={styles.title}>
        <Link to={href} onClick={() => onArticleClick?.(article)}>
          {article.title}
        </Link>
      </h3>
      <div className={styles.meta}>
        {source ? <span className={styles.source}>{source}</span> : null}
        <span className={styles.date}>{formatDeskTime(article.publishedAt)}</span>
        {cats ? (
          <span className={styles.categories} title="Story categories">
            {cats}
          </span>
        ) : null}
        {article.qualityScore != null && (
          <span className={styles.quality}>{Math.round(article.qualityScore * 100)}%</span>
        )}
        {article.wordCount ? (
          <span className={styles.readTime}>{Math.ceil(article.wordCount / 200)} min</span>
        ) : null}
      </div>
      {article.tags && article.tags.length > 0 && (
        <div className={styles.tags}>
          {article.tags.slice(0, 3).map((tag) => (
            <span key={tag} className={styles.tag}>
              {tag}
            </span>
          ))}
        </div>
      )}
    </article>
  );
};

export default ArticleTeaser;
